"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epics = _interopRequireDefault(require("settings-ui-sdk/Blogs/epics"));

var _epics2 = _interopRequireDefault(require("settings-ui-sdk/BlogPosts/epics"));

var _epics3 = _interopRequireDefault(require("settings-ui-sdk/BlogLanguages/epics"));

var _UpdateBlogSettings = _interopRequireDefault(require("../stagedObjects/UpdateBlogSettings"));

var _NotificationEmailSettings = require("../stagedObjects/NotificationEmailSettings");

var _redirectOnBlogCreation = _interopRequireDefault(require("./redirectOnBlogCreation"));

var _redirectOnBlogDeletion = _interopRequireDefault(require("./redirectOnBlogDeletion"));

var _languagesEpics = require("./languagesEpics");

var _epics4 = _interopRequireDefault(require("settings-ui-sdk/BlogNotificationEmails/epics"));

var _epics5 = require("settings-ui-sdk/DesignTemplates/epics");

var _epics6 = require("settings-ui-sdk/Lists/epics");

var _default = (0, _reduxObservable.combineEpics)(_epics.default, _epics2.default, _epics3.default, _epics4.default, _epics5.fetchBlogTemplates, _redirectOnBlogCreation.default, _redirectOnBlogDeletion.default, _UpdateBlogSettings.default.getResetAllStagedChangesEpic(), _NotificationEmailSettings.InstantNotificationEmailSettings.getResetAllStagedChangesEpic(), _NotificationEmailSettings.DailyNotificationEmailSettings.getResetAllStagedChangesEpic(), _NotificationEmailSettings.WeeklyNotificationEmailSettings.getResetAllStagedChangesEpic(), _NotificationEmailSettings.MonthlyNotificationEmailSettings.getResetAllStagedChangesEpic(), _languagesEpics.maybeFetchDateTimeFormatOptions, _languagesEpics.maybeFetchMonthFormatOptions, _epics6.fetchContactLists);

exports.default = _default;
module.exports = exports.default;